export const schedule = {
  go: {
    start: "Start",
    cantNow: "Can't do it now",
    details: "Details",
  },
  notFound: 'Schedule not found',
  loadError: {
    title: 'Couldn’t load this schedule',
    description: 'Check your connection and try again.',
  },
  startFailed: 'Unable to start this inspection.',
  starting: 'Starting...',
  loadingAsset: 'Loading asset…',
  breadcrumb: {
    backToRequest: '← Back to request',
    scheduledInspection: 'Scheduled inspection',
  },
  calendarInvite: {
    titleWithAsset: 'Inspection: {{asset}}',
    titleFallbackAsset: 'Asset',
    descriptionChecklist: 'Checklist: {{name}}',
    addToCalendar: "Add to calendar",
    notNow: "Not now",
    confirmedTitle: "Date confirmed",
    confirmedBody: "The team has been notified. Add the visit to your calendar?",
  },
  sourceRequest: {
    title: 'From request',
    fallback: 'This scheduled inspection remains linked to the source request timeline.',
    openRequest: 'Open request',
  },
  visit: {
    label: 'Visit',
    confirmed: 'Confirmed by contact',
    awaitingConfirmation: 'Awaiting contact confirmation',
  },
  readOnlyAssetNotice: 'This asset is shared with you as read-only, so an inspection cannot be started against it. Ask its owner for edit access, or run this inspection from an asset in your own workspace.',
  reschedule: {
    accessibilityLabel: 'Reschedule inspection',
    label: 'Reschedule',
  },
  changeRequest: {
    sent: 'Request sent',
    savedOffline: 'Saved on this device — it will send when you are back online',
    sendFailed: 'Could not send the request',
    decideFailed: 'Could not record the decision',
    photosNeedSignal: 'Photos need signal to upload. Remove them to save this request offline, or try again once you are back online.',
  },
  overflow: {
    moreActionsLabel: 'More schedule actions',
    sheetTitle: 'Schedule options',
  },
  status: {
    skipped: "Skipped",
    upcoming: 'Upcoming',
    due: 'Due now',
    overdue: 'Overdue',
    completed: 'Completed',
    cancelled: 'Cancelled',
  },
  alerts: {
    errorTitle: 'Error',
    templateMissing: 'Checklist not found.',
    cancelTitle: 'Cancel schedule',
    cancelMessage: 'Are you sure you want to cancel this scheduled inspection?',
    cancelConfirm: 'Cancel schedule',
    no: 'No',
    deleteTitle: 'Delete schedule',
    deleteMessage: 'This will permanently remove this schedule.',
    deleteConfirm: 'Delete',
  },
  labels: {
    asset: 'Asset',
    checklist: 'Checklist',
    assignedTo: 'Assigned to',
    unassigned: 'Unassigned',
    recurrence: "Repeats",
    reminders: 'Reminders',
    none: 'None',
    seriesEndDate: 'Series end date',
    seriesEndTime: 'Series end time',
    maxCompletedRuns: "Stops after",
  },
  seriesEnd: {
    sectionTitle: 'Optional series limits',
    helper: 'Leave blank for no limit. The series stops when either limit is reached.',
    maxPlaceholder: 'e.g. 12',
    errors: {
      maxPositive: 'Enter a whole number of at least 1, or leave max runs blank.',
      invalidEnd: 'Series end date and time are invalid.',
      endBeforeStart: 'Series end must be on or after the scheduled start.',
    },
  },
  detail: {
    stopRepeat: {
      failed: "Could not stop the repeat. Check your connection and try again.",
      done: "This inspection no longer repeats.",
      confirm: "Stop repeating",
      message: "This visit stays. No more visits will be raised after it.",
      title: "Stop repeating this inspection?",
      action: "Stop repeating",
    },
    seriesEnds: "Repeat ends",
    maxRuns_one: "Stops after {{count}} visit",
    maxRuns_other: "Stops after {{count}} visits",
    unlimitedRuns: "No limit",
    noEndDate: 'No end date',
  },
  list: {
    untilDate: 'Until {{date}}',
    maxRunsChip_one: "Up to {{count}} visit",
    maxRunsChip_other: "Up to {{count}} visits",
    typeInspection: 'Inspection',
    typeJob: 'Job',
    filterActive: 'Active',
    filterPast: 'Past',
    filterAll: 'All',
    overdueChip: 'Overdue',
    scheduleWork: 'Schedule work',
    scheduleSheetTitle: 'What do you want to schedule?',
    emptyTitle: 'Nothing scheduled',
    emptyActiveSubtitle: 'Schedule an inspection or a job and it appears here.',
    emptyPastSubtitle: 'No past scheduled work.',
    emptyAllSubtitle: 'No scheduled work yet.',
  },
  unknownAsset: 'Unknown asset',
  unknownChecklist: 'Unknown checklist',
  templateMeta_one: '{{count}} item · {{category}}',
  templateMeta_other: '{{count}} items · {{category}}',
  recurrence: {
    none: "One-off",
    hourly: "Every hour",
    daily: "Every day",
    weekly: "Every week",
    biweekly: "Every 2 weeks",
    monthly: "Every month",
    quarterly: "Every 3 months",
    yearly: "Every year",
  },
  reminder: {
    at_time: 'At scheduled time',
    '15min': '15 minutes before',
    '30min': '30 minutes before',
    '1hr': '1 hour before',
    '2hr': '2 hours before',
    '1day': '1 day before',
    '2day': '2 days before',
  },
  actions: {
    startNow: 'Start inspection now',
    startFor: "Start for {{name}}",
    cancelSchedule: 'Cancel schedule',
    viewInspection: 'View inspection',
    delete: 'Delete',
  },
  planner: {
    subtitle: 'Pick a date, assign a person, and lock it in.',
    scheduleCta: 'Schedule',
    scheduleInspection: 'Schedule inspection',
    scheduleJob: 'Schedule job',
  },
  create: {
    createChecklistCta: 'Create checklist',
    noChecklistsHint: 'No checklists yet. Create one to continue scheduling.',
    overlayReturnFootnote: 'Opens in an overlay. When you save, you return here with the checklist selected.',
    ctaAccessibility: 'Create checklist and return to schedule',
  },
} as const;
